import { LocalizedText } from "../../components/LocalizedText";
import * as React from 'react';
import GameContainer from '../../components/GameContainer';
import { NpcMenu } from '../../components/NpcMenu/NpcMenu';
import { TopMenu } from '../TopMenu/TopMenu';
import { toServer } from '../../util/ServerSocket';

export const LasNoches: React.FC<{}> = () => {
  return (
    <GameContainer src={`scenes/backgrounds/3101.png`}>
      <TopMenu />
      <NpcMenu npc={17003} onEnd={() => toServer('switchScene', 171)} moveable={false}>
        <div
          className="clickable"
          onClick={() =>
            toServer('lasNochesEnter', {}, (response?: { error?: string }) => {
              if (response?.error) return;
              toServer('switchScene', 61);
            })
          }><LocalizedText text={"Common Route"} /></div>
        <div className="" onClick={() => {}}><LocalizedText text={"Express Route"} /></div>
        <div className="" onClick={() => {}}><LocalizedText text={"VIP Route"} /></div>
      </NpcMenu>
    </GameContainer>
  );
};
